<template>
  <div>
    <template v-if="planningOrder">
      <!-- First Row -->
      <b-row>
        <b-col
          cols="12"
          xl="9"
          lg="8"
          md="7"
        >
          <planning-info-card :planning-order="planningOrder" />
        </b-col>
        <b-col
          cols="12"
          md="5"
          xl="3"
          lg="4"
        >
          <planning-deliver-card :planning-order="planningOrder" />
        </b-col>
      </b-row>

      <b-row>
        <b-col
          cols="12"
          lg="7"
        >
          <planning-management-card
            :planning-order="planningOrder"
            :user-data="userData"
          />
        </b-col>
        <b-col
          cols="12"
          lg="5"
        >
          <planning-comments-card
            :planning-order="planningOrder"
            :user-data="userData"
          />
        </b-col>
      </b-row>
    </template>
    <template v-else>
      <b-card>
        <b-skeleton
          animation="wave"
          width="85%"
        />
        <b-skeleton
          animation="wave"
          width="55%"
        />
        <b-skeleton
          animation="wave"
          width="70%"
        />
      </b-card>
    </template>

  </div>
</template>

<script>
import store from '@/store'
import router from '@/router'
import { ref, onUnmounted } from '@vue/composition-api'
import {
  BRow, BCol, BAlert, BLink, BSkeleton, BCard,
} from 'bootstrap-vue'
import api from '@/plugin/axios'
import PlanningInfoCard from './PlanningInfoCard.vue'
import PlanningDeliverCard from './PlanningDeliverCard.vue'
import PlanningCommentsCard from './PlanningCommentsCard.vue'
import PlanningManagementCard from './PlanningManagementCard.vue'

export default {
  components: {
    BRow,
    BCol,
    BAlert,
    BLink,
    BSkeleton,
    BCard,

    // Local Components
    PlanningInfoCard,
    PlanningDeliverCard,
    PlanningCommentsCard,
    PlanningManagementCard,
  },
  data() {
    return {
      planningOrder: null,
      userData: JSON.parse(localStorage.getItem('userData')),
    }
  },
  async created() {
    const [response] = await Promise.all([
      api.get(`/api/planning-orders/${this.$route.params.id}`),
    ])

    this.planningOrder = response.data
    console.log(this.planningOrder)
  },
}
</script>

<style>

</style>
